import { ButtonBase } from '@mui/material';
import { ReactNode } from 'react';
import { cssWhen } from '../../../../../shared/utils/themeUtils';
import classes from './OrderCurrencyExchangeSelectionCard.module.scss';

export type OrderCurrencyExchangeSelectionCardProps = {
  isSelected?: boolean;
  disabled?: boolean;
  error?: boolean;
  onClick?: () => void;
  children: ReactNode;
  className?: string;
  readOnly: boolean;
};

export const OrderCurrencyExchangeSelectionCard = ({
  isSelected,
  disabled,
  error,
  onClick,
  children,
  className,
  readOnly,
}: OrderCurrencyExchangeSelectionCardProps) => {
  return (
    <ButtonBase
      className={cssWhen(
        classes.card,
        [isSelected, classes.cardIsSelected],
        [disabled, classes.cardIsDisabled],
        [error, classes.cardHasError],
        className,
      )}
      onClick={readOnly ? undefined : onClick}
      disabled={disabled}
      disableRipple
    >
      {children}
    </ButtonBase>
  );
};
